import { UrlAdaptor } from '@syncfusion/ej2-data';
import axios from 'axios';

export class AxiosAdaptor extends UrlAdaptor {
  processQuery(dm, query, hierarchyFilters) {
    const request = super.processQuery(dm, query, hierarchyFilters);
    return request;
  }

  makeRequest(request, deffered, args, query) {
    axios({
      method: request.type,
      url: request.url,
      data: request.data,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((error) => {
        deffered.reject([{ error: error }]);
      });
  }
}